import { faXmarkLarge } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { PlayerInFixtureStatusIconType } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Clock } from '@sorare/core/src/atoms/icons/Clock';
import { Tag } from '@sorare/core/src/atoms/ui/Tag';

import PlayerScore from '@sorare/marketplace/src/components/card/USSports/PlayerScore';

const IconTag = styled(Tag)`
  color: var(--c-neutral-600);
  background-color: var(--c-neutral-300);
`;

type Props = {
  score: number;
  iconType: PlayerInFixtureStatusIconType;
  className?: string;
};

export const PlayerFixtureScoreState = ({
  score,
  iconType,
  className,
}: Props) => {
  const canShowScore =
    score > 0 || iconType === 'IN_PROGRESS_SCORE' || iconType === 'FINAL_SCORE';
  const scoreIsFinal = iconType === 'FINAL_SCORE' || iconType === 'INACTIVE';

  return (
    <>
      {iconType === 'INACTIVE' && (
        <IconTag round color="grey" className={className}>
          <FontAwesomeIcon icon={faXmarkLarge} />
        </IconTag>
      )}
      {iconType === 'NO_GAME' && (
        <PlayerScore round score="NG" className={className} />
      )}
      {iconType === 'PENDING' && (
        <IconTag round color="grey" className={className}>
          <Clock />
        </IconTag>
      )}
      {iconType === 'DID_NOT_PLAY' && (
        <PlayerScore round score="DNP" className={className} />
      )}
      {canShowScore && (
        <PlayerScore
          round
          score={score}
          className={className}
          final={scoreIsFinal}
        />
      )}
    </>
  );
};
